import styled from 'styled-components'

const Title = styled('h1')`
  font-family: Slackey;
  font-weight: 500;
  margin-bottom: 35px;
`

function Header() {
  return <Title> toodoo </Title>
}

export default Header
